import { Attrs, MinzeElement } from 'minze'

export interface LvcBoxXIcon {
  dataWidth: number
  dataHeight: number
}

export class LvcBoxXIcon extends MinzeElement {
  attrs: Attrs = [
    ['data-width', 28],
    ['data-height', 28],
  ]
  html = () => `
    <svg width="${this.dataWidth}" height="${this.dataHeight}" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#a)">
        <path d="M9 5.385h12.26c.145 0 .267.123.267.27 0 0-.206 2.193 0 5.766.206 3.572 0 10.847 0 10.847a.335.335 0 0 1-.335.34H4.922a.453.453 0 0 1-.45-.455s-.205-5.127 0-8.153c.199-3.034 0-8.269 0-8.269 0-.192.153-.346.344-.346H5.5M9 10c2.578 2.25 7.787 7 8 8m0-8c-2.458 2.36-7.292 7.056-8 8M7.168 5.385h.1" stroke="currentColor" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" d="M0 0h28v28H0z"/>
        </clipPath>
      </defs>
    </svg>
  `
  css = () => `
    
  `
}
